import { useLocation } from "react-router";
import { Typography } from "@mui/material";
import AddRoleForm from "../RolesForm/AddRoleForm";
import BreadCrumb from "../../../../../pages/breadcrumb/BreadCrumb";


const RolesModules = () => {
    const location = useLocation();
    const BreadCrumbData = location.state || [];

    return (
        <div className="!p-6">
            {BreadCrumbData && BreadCrumbData?.length > 0 &&
                    <div className="mb-2"><BreadCrumb BreadCrumbsListing={BreadCrumbData} /></div>}
            <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
                <Typography variant="h5" className="mb-3">Basic Details</Typography>
                <AddRoleForm />
            </div>
        </div>
    );
};

export default RolesModules;
